<template>
  <Base
    :on-submit="(params) => api.template.create(params)"
    :triger-prevent="trigerPrevent"
    field-details-route="field-details"
    templates-route="templates"
    ref="base"
    :is-ticket="true"
  />
</template>

<script>
import { mapActions } from 'vuex';

import Base from '../base/base';

import { beforeRouteLeaveFunction } from '../base/common';

import api from '../../../../api/index';

export default {
  title: 'NewTicketTemplate',
  components: { Base },
  beforeRouteLeave(to, from, next) {
    const changed = this.$refs.base.exit();
    return beforeRouteLeaveFunction(to, from, next, this.disablePrevent, this.$translate, changed, this.clearTemplates);
  },
  data() {
    return {
      api: api,
      disablePrevent: false,
    };
  },
  ...mapActions({ clearTemplates: 'template/clearTemplates' }),
  methods: {
    trigerPrevent: function (value) {
      this.disablePrevent = value;
    },
  },
};
</script>
